// Resolving the postcode for an imported document.
//
// A postcode written into the address line is what the customer actually gave
// us; the one the subdistrict splitter returns is *inferred* from
// subdistricts.json, which lags Thailand Post in places (อำเภอบางเสาธง was
// still filed under บางพลี's 10540 instead of its own 10570). So the explicit
// code wins and the lookup is only a fallback — that way PostcodeCode can
// never contradict the address printed on the document.

// Last standalone 5-digit token in the text. Space-delimited on both sides so
// "31/2" and a 10-digit phone number don't match, and never leading-zero so we
// don't pick up the "00000" placeholder used for buyers with no tax ID.
export const zipCodeInText = address => {
  const matches = String(address == null ? "" : address).match(
    /(?:^|\s)([1-9]\d{4})(?=\s|$)/g
  );
  if (!matches) {
    return "";
  }
  return matches[matches.length - 1].trim();
};

// splitResult is whatever Splitter.split() returned — an object with a
// `zipcode`, or "" when it could not match the address at all.
export const resolveZipCode = (address, splitResult) => {
  const explicit = zipCodeInText(address);
  if (explicit) {
    return explicit;
  }
  return splitResult && splitResult.zipcode ? splitResult.zipcode : "";
};

export default { zipCodeInText, resolveZipCode };
